import { app } from '@packages/app';
import { ReduxServiceProvider } from '@redux-src/ReduxServiceProvider';

export const getState = (): any => {
    const reduxService: ReduxServiceProvider = app(ReduxServiceProvider);
    return reduxService.getState();
};
